import {
  skipToken,
  useCreateTimelineEventMutation,
  useGetTimelineQuery,
} from "metabase/api";
import type { ModalComponentProps } from "metabase/common/components/ModalRoute";
import { useNavigate } from "metabase/router";
import NewEventModal from "metabase/timelines/common/components/NewEventModal";
import * as Urls from "metabase/urls";
import type {
  CreateTimelineEventRequest,
  Timeline,
  TimelineEvent,
} from "metabase-types/api";

import LoadingAndErrorWrapper from "../../components/LoadingAndErrorWrapper";

function NewEventModalContainer({ params, onClose }: ModalComponentProps) {
  const navigate = useNavigate();
  const [createTimelineEvent] = useCreateTimelineEventMutation();
  const id = Urls.extractEntityId(params.timelineId);
  const {
    data: timeline,
    isLoading,
    error,
  } = useGetTimelineQuery(id != null ? { id, include: "events" } : skipToken);

  if (isLoading || error || !timeline) {
    return (
      <LoadingAndErrorWrapper loading={isLoading} error={error} noWrapper />
    );
  }

  const onSubmit = async (
    values: Partial<TimelineEvent>,
    _collection?: unknown,
    timeline?: Timeline,
  ) => {
    // Unjustified type cast. FIXME
    await createTimelineEvent(values as CreateTimelineEventRequest).unwrap();
    if (timeline) {
      navigate(Urls.timelineInCollection(timeline));
    }
  };

  return (
    <NewEventModal
      source="collections"
      timelines={[timeline]}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  );
}

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default NewEventModalContainer;
